import React, { useEffect, useState } from "react";
import {
  Col,
  FormGroup,
  Input,
  Label,
  ModalBody,
  ModalFooter,
  Row,
  Button,
} from "reactstrap";
import Axios from "../../../lib/Axios";
import ToastHandler from "../../../components/Common/ToastHandler";

const defaultToast = { title: "", message: "" };

const ModalKeyValueEditor = ({ data, mode = "create", toggle, refetch }) => {
  const [keyInput, setKeyInput] = useState("");
  const [valueInput, setValueInput] = useState("");
  const [toast, setToast] = useState(false);
  const [toastData, setToastData] = useState(defaultToast);
  const isEdit = mode === "edit";

  useEffect(() => {
    if (data?.keyName) {
      setKeyInput(data.keyName);
    } else {
      setKeyInput("");
    }
  }, [data?.keyName]);

  useEffect(() => {
    if (data?.value) {
      try {
        setValueInput(JSON.stringify(data.value, null, 2));
      } catch (error) {
        setValueInput(String(data.value));
      }
    } else {
      setValueInput("");
    }
  }, [data?.value]);

  const showToast = (title, message) => {
    setToastData({ title, message });
    setToast(true);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!keyInput.trim()) {
      showToast("Error", "Key is required");
      return;
    }
    if (!valueInput.trim()) {
      showToast("Error", "Value is required");
      return;
    }
    let parsedValue;
    try {
      parsedValue = JSON.parse(valueInput);
    } catch (error) {
      showToast("Error", "Value must be valid JSON");
      return;
    }
    try {
      await Axios.post("/cms/cms-set/modal-key-value", {
        [keyInput.trim()]: parsedValue,
      });
      showToast("Success", isEdit ? "Key updated" : "Key created");
      await refetch();
      toggle();
    } catch (error) {
      if (error?.response?.data?.message) {
        showToast("Error", error.response.data.message);
      } else {
        showToast("Error", "Unable to save key");
      }
    }
  };

  return (
    <>
      <form className="tablelist-form" onSubmit={handleSubmit}>
        <ModalBody>
          <Row className="g-3 align-items-start">
            <Col md={6}>
              <FormGroup>
                <Label for="modal-key-input">Key</Label>
                <Input
                  id="modal-key-input"
                  type="text"
                  value={keyInput}
                  onChange={(e) => setKeyInput(e.target.value)}
                  placeholder="e.g. broadcast_modal"
                  disabled={isEdit}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="modal-value-input">Value (JSON)</Label>
                <Input
                  id="modal-value-input"
                  type="textarea"
                  rows="8"
                  value={valueInput}
                  onChange={(e) => setValueInput(e.target.value)}
                  placeholder='{"title": "...", "content": "..."}'
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="justify-content-end">
          <Button type="button" color="light" onClick={toggle}>
            Cancel
          </Button>
          <Button type="submit" color="success">
            {isEdit ? "Save" : "Create"}
          </Button>
        </ModalFooter>
      </form>
      <ToastHandler
        open={toast}
        setOpen={setToast}
        duration={2000}
        message={toastData.message}
        title={toastData.title}
      />
    </>
  );
};

export default ModalKeyValueEditor;

